import React, { useEffect, useRef, useState } from 'react';
import { DateRange } from 'react-date-range';
import { pt } from 'date-fns/locale';
import { Dropdown, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';

import {
	UilCalendarAlt,
	UilEllipsisV,
	UilSearch,
	UilChartDown,
	UilBoltAlt,
	UilTear,
	UilBusAlt,
	UilPhone,
	UilTrophy,
	UilAngleDown,
} from '@iconscout/react-unicons';

import * as S from './style';
import moment from 'moment';
interface CalendarProps {
	height: number;
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	setShowDropdown(b: boolean): void;
}

export function CalendarContainer({
	height,
	range,
	setRange,
	setShowDropdown,
}: CalendarProps): any {
	const [tRange, setTRange] = useState([...range]);

	useEffect(() => {
		setTRange([...range]);
	}, [range]);
	return (
		<S.CalendarSettings height={height}>
			<DateRange
				// showMonthAndYearPickers={false}
				// showMonthArrow={false}
				showDateDisplay={false}
				// twoStepChange={true}

				// scroll={{enabled: true}}
				// customInput={<InputMask mask='99/99/9999' />}
				startDatePlaceholder='data inicial'
				endDatePlaceholder='data final'
				rangeColors={['#28A745', '#FFFFFF']}
				editableDateInputs
				onChange={(item: any) => {
					if (item.selection) {
						/// /console.log(item.selection);
						setTRange([item.selection]);
					}
					/// /console.log(item);
					// setRangeHeader([item.selection]);
				}}
				moveRangeOnFirstSelection={false}
				ranges={tRange}
				months={2}
				direction='horizontal'
				locale={pt}
				dateDisplayFormat='P'
				// dateDisplayFormat="'data': P"
				monthDisplayFormat='MMMM yyy'
				weekdayDisplayFormat='EEEEE'
				weekStartsOn={0}
				//
			/>
			<div className='calendario_footer'>
				<button
					onClick={(e) => {
						e.preventDefault();
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_cancelar'>
					Cancelar
				</button>
				<button
					onClick={(e) => {
						e.preventDefault();
						setRange([...tRange]);
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_confirmar'>
					Confirmar
				</button>
			</div>
		</S.CalendarSettings>
	);
}

interface SingleCalendarProps {
	item: any;
	setItem(i: any): void;
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
}

export function SingleDropdownCalendar({
	item,
	range,
	setItem,
	setRange,
}: SingleCalendarProps) {
	const [showDropdown, setShowDropdown] = useState(false);
	const dropdownRef = useRef<any>(null);
	const [height, setHeight] = useState(0);
	useEffect(() => {
		let h = 0;
		if (dropdownRef && dropdownRef.current) {
			h = dropdownRef.current.clientHeight;

			setHeight(h);
		}
	}, [dropdownRef, showDropdown]);
	function handleClickOutside(e: any): void {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setShowDropdown(false);
		}
	}
	useOutsideAlert(dropdownRef, handleClickOutside);

	function getDateFormat() {
		const from = moment(range[0].startDate).format('DD/MM/YY');
		const to = moment(range[0].endDate).format('DD/MM/YY');

		return `${from} a ${to}`;
	}

	return (
		<Dropdown ref={dropdownRef} drop={'left'} show={showDropdown}>
			<Dropdown.Toggle className='dropdown-none'>
				<S.HeaderButton
					//key={data.dia}
					onClick={(e) => {
						e.preventDefault();
						setItem('personalizado');
						setShowDropdown(!showDropdown);
						//handleRange(data.dia);
					}}
					active={'personalizado' === item}>
					<span className='MenuPersonalizadoSvgContainer'>
						<UilCalendarAlt />
					</span>{' '}
					<p>
						{item === 'personalizado' ? `${getDateFormat()}` : 'personalizado'}
					</p>
				</S.HeaderButton>
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<CalendarContainer
					range={range}
					setRange={setRange}
					height={height}
					setShowDropdown={setShowDropdown}
				/>
			</Dropdown.Menu>
		</Dropdown>
	);
}

export function useOutsideAlert(ref: any, handleClickOutside: any): void {
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('mousedown', handleClickOutside);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ref]);
}

interface DropdownProps {
	label?: string;
	children?: React.ReactNode;
	options: {
		label: string;
		value: string;
		f?(): void;
	}[];
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	left?: boolean;
}
interface CalendarProps {
	height: number;
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	setShowDropdown(b: boolean): void;
}

interface CalendarInsideProps {
	height: number;
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	setShowDropdown(b: boolean): void;
	left?: boolean;
	width: number;
}

function CalendarContainerInside({
	height,
	range,
	setRange,
	setShowDropdown,
	left,
	width,
}: CalendarInsideProps): any {
	const [tRange, setTRange] = useState([...range]);

	return (
		<S.CalendarSettingsInside width={width} left={left} height={height}>
			<p className='calendario_title'>Período Personalziado</p>
			<DateRange
				// showMonthAndYearPickers={false}
				// showMonthArrow={false}
				showDateDisplay={false}
				// twoStepChange={true}

				// scroll={{enabled: true}}
				// customInput={<InputMask mask='99/99/9999' />}
				startDatePlaceholder='data inicial'
				endDatePlaceholder='data final'
				rangeColors={['#28A745', '#FFFFFF']}
				editableDateInputs
				onChange={(item: any) => {
					if (item.selection) {
						/// /console.log(item.selection);
						setTRange([item.selection]);
					}
					/// /console.log(item);
					// setRangeHeader([item.selection]);
				}}
				moveRangeOnFirstSelection={false}
				ranges={tRange}
				months={2}
				direction='horizontal'
				locale={pt}
				dateDisplayFormat='P'
				// dateDisplayFormat="'data': P"
				monthDisplayFormat='MMMM yyy'
				weekdayDisplayFormat='EEEEE'
				weekStartsOn={0}
				//
			/>
			<div className='calendario_footer'>
				<button
					onClick={(e) => {
						e.preventDefault();
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_cancelar'>
					Cancelar
				</button>
				<button
					onClick={(e) => {
						e.preventDefault();
						setRange([...tRange]);
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_confirmar'>
					Confirmar
				</button>
			</div>
		</S.CalendarSettingsInside>
	);
}

export const CalendarDropdown: React.FC<DropdownProps> = ({
	label,
	children,
	options,
	range,
	setRange,
	left,
}) => {
	const [showDropdown, setShowDropdown] = useState(false);
	const [selectItem, setSelectItem] = useState(
		options && options[0] && options[0].value ? options[0].value : ''
	);
	const [selectItemLabel, setSelectItemLabel] = useState(
		options && options[0] && options[0].label ? options[0].label : ''
	);
	const [showCalendar, setShowCalendar] = useState(false);

	console.log(showCalendar);
	const dropdownRef = useRef<any>(null);

	const [height, setHeight] = useState(0);
	const [width, setWidth] = useState(0);

	function dateRange(): string {
		const r = range[0];
		if (r) {
			const sdate = moment(r.startDate).format('DD/MM/YYYY');
			const edate = moment(r.endDate).format('DD/MM/YYYY');
			const s = `${sdate} - ${edate}`;
			return s;
		}
		return '';
	}

	useEffect(() => {
		let h = 0;
		let w = 0;
		if (dropdownRef && dropdownRef.current) {
			h = dropdownRef.current.clientHeight;
			w = dropdownRef.current.clientWidth;

			console.log(dropdownRef.current);
			console.log(dropdownRef.current.clientHeight);
			setHeight(h);
			setWidth(w);
		}
	}, [dropdownRef, showDropdown]);

	useEffect(() => {
		const f = options.find((o) => o.value === selectItem);
		if (f) {
			setSelectItemLabel(f.label);
		}
	}, [selectItem]);

	function handleClickOutside(e: any): void {
		if (
			dropdownRef.current &&
			dropdownRef.current !== null &&
			!dropdownRef.current.contains(e.target)
		) {
			setShowDropdown(false);
		}
	}
	useOutsideAlert(dropdownRef, handleClickOutside);

	return (
		<S.DropdownContainer height={height} ref={dropdownRef}>
			<div
				onClick={(e) => {
					e.preventDefault();
					setShowDropdown(!showDropdown);
				}}>
				{children}
			</div>
			{showDropdown && (
				<div className='dropdown-menu'>
					{showCalendar && (
						<CalendarContainerInside
							left={left}
							range={range}
							setRange={setRange}
							height={height}
							setShowDropdown={setShowDropdown}
							width={width}
						/>
					)}
					{options.map((o) => {
						return (
							<S.DropdownItem
								onClick={(e) => {
									e.preventDefault();
									setSelectItem(o.value);
									if (o.value !== 'personalizado') {
										setShowDropdown(false);
										setShowCalendar(false);
										if (o.f) {
											o.f();
										}
									} else {
										setShowCalendar(true);
									}
								}}
								active={selectItem === o.value}>
								{o.label}
							</S.DropdownItem>
						);
					})}
				</div>
			)}
		</S.DropdownContainer>
	);
};

interface ModalProps {
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	setModalVisible(b: boolean): void;
	modalVisible: boolean;
}

export function CalendarModal({
	range,
	setRange,
	setModalVisible,
	modalVisible,
}: ModalProps) {
	return (
		<S.ModalCalendar
			onClick={(e) => {
				e.preventDefault();
				setModalVisible(false);
			}}>
			<CalendarModalContainer
				range={range}
				setRange={setRange}
				setShowDropdown={setModalVisible}
				showDropdown={modalVisible}
			/>
		</S.ModalCalendar>
	);
}

interface ModalCalendarProps {
	range: { startDate: Date; endDate: Date; key: string }[];
	setRange(r: { startDate: Date; endDate: Date; key: string }[]): void;
	setShowDropdown(b: boolean): void;
	showDropdown: boolean;
}

export function CalendarModalContainer({
	range,
	setRange,
	setShowDropdown,
	showDropdown,
}: ModalCalendarProps): any {
	const [tRange, setTRange] = useState([...range]);

	useEffect(() => {
		if (showDropdown) setTRange([...range]);
	}, [showDropdown]);

	return (
		<S.CalendarModalSettings
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
			}}>
			<DateRange
				// showMonthAndYearPickers={false}
				// showMonthArrow={false}
				showDateDisplay={false}
				// twoStepChange={true}

				// scroll={{enabled: true}}
				// customInput={<InputMask mask='99/99/9999' />}
				startDatePlaceholder='data inicial'
				endDatePlaceholder='data final'
				rangeColors={['#18AA36', '#FFFFFF']}
				editableDateInputs
				onChange={(item: any) => {
					if (item.selection) {
						/// /console.log(item.selection);
						setTRange([item.selection]);
					}
					/// /console.log(item);
					// setRangeHeader([item.selection]);
				}}
				moveRangeOnFirstSelection={false}
				ranges={tRange}
				months={2}
				direction='horizontal'
				locale={pt}
				dateDisplayFormat='P'
				// dateDisplayFormat="'data': P"
				monthDisplayFormat='MMMM yyy'
				weekdayDisplayFormat='EEEEE'
				weekStartsOn={0}
				//
			/>
			<div className='calendario_footer'>
				<button
					onClick={(e) => {
						e.preventDefault();
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_cancelar'>
					Cancelar
				</button>
				<button
					onClick={(e) => {
						e.preventDefault();
						setRange([...tRange]);
						setShowDropdown(false);
					}}
					type='button'
					className='calendario_footer_confirmar'>
					Confirmar
				</button>
			</div>
		</S.CalendarModalSettings>
	);
}
